import { AppBarSubmenu, AppBarSubmenuTheme } from "@iventis/components";
import React, { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { devSubMenuItems } from "./dev.types";

const DevComponent = () => {
    const nav = useNavigate();
    const location = useLocation();
    const selectedItem = location?.pathname?.replace("/dev", "").replace("/", "");
    useEffect(() => {
        if (selectedItem === "") {
            nav(devSubMenuItems[0].id);
        }
    }, [selectedItem]);
    return (
        <>
            <AppBarSubmenu
                items={devSubMenuItems}
                selectedItem={selectedItem}
                onItemClick={(item) => nav({ pathname: `/dev/${item.id}` })}
                fullScreenTitle={selectedItem}
                mobileOpen={false}
                theme={AppBarSubmenuTheme.Administrative}
            />
            <Outlet />
        </>
    );
};

export default DevComponent;
